export default __webpack_public_path__ + "static/media/sopOpenIcon.b301b128.svg";